const GAD = [
  {
    id: 1,
    questionId: "GAD_Q1",
    name: "Feeling nervous, anxious, or on edge",
    value: 0,
  },
  {
    id: 2,
    questionId: "GAD_Q2",
    name: "Not being able to stop or control worrying",
    value: 0,
  },
  {
    id: 3,
    questionId: "GAD_Q3",
    name: "Worrying too much about different things",
    value: 0,
  },
  {
    id: 4,
    questionId: "GAD_Q4",
    name: "Trouble relaxing",
    value: 0,
  },
  {
    id: 5,
    questionId: "GAD_Q5",
    name: "Being so restless that it is hard to sit still",
    value: 0,
  },
  {
    id: 6,
    questionId: "GAD_Q6",
    name: "Becoming easily annoyed or irritable",
    value: 0,
  },
  {
    id: 7,
    questionId: "GAD_Q7",
    name: "Feeling afraid, as if something awful might happen",
    value: 0,
  },
];

const Connor = [
  { id: 1, questionId: "CARS_Q1", name: "RESTLESS AND OVERACTIVE", value: 0 },
  { id: 2, questionId: "CARS_Q2", name: "EXCITABLE,IMPULSIVE", value: 0 },
  { id: 3, questionId: "CARS_Q3", name: "DISTURBS OTHER CHILDREN", value: 0 },
  {
    id: 4,
    questionId: "CARS_Q4",
    name: "FAILS TO FINISH THINGS - SHORT ATTENTION SPAN",
    value: 0,
  },
  {
    id: 5,
    questionId: "CARS_Q5",
    name: "CONSTANTLY FIDGETING",
    value: 0,
  },
  {
    id: 6,
    questionId: "CARS_Q6",
    name: "INATTENTIVE, EASILY DISTRACTED",
    value: 0,
  },
  {
    id: 7,
    questionId: "CARS_Q7",
    name: "DEMAND MUST BE MET IMMEDIATELY - EASILY FRUSTRATED",
    value: 0,
  },
  {
    id: 8,
    questionId: "CARS_Q8",
    name: "CRIES OFTEN AND EASILY",
    value: 0,
  },
  {
    id: 9,
    questionId: "CARS_Q9",
    name: "MOOD CHANGES QUICLY AND DRASTICALLY",
    value: 0,
  },
  {
    id: 10,
    questionId: "CARS_Q10",
    name: "TEMPER OUTBURST, EXPLOSIVE AND UNPREDICTABLE BEHAVIOUR",
    value: 0,
  },
];

const PHQ = [
  {
    id: 1,
    questionId: "PHQ_Q1",
    name: "Little interest or pleasure in doing things",
    value: 0,
  },
  {
    id: 2,
    questionId: "PHQ_Q2",
    name: "Feeling down, depressed, or hopeless",
    value: 0,
  },
  {
    id: 3,
    questionId: "PHQ_Q3",
    name: "Trouble falling or staying asleep, or sleeping too much",
    value: 0,
  },
  {
    id: 4,
    questionId: "PHQ_Q4",
    name: "Feeling tired or having little energy",
    value: 0,
  },
  {
    id: 5,
    questionId: "PHQ_Q5",
    name: "Poor appetite or overeating",
    value: 0,
  },
  {
    id: 6,
    questionId: "PHQ_Q6",
    name: "Feeling bad about yourself or that you are a failure or have let yourself or your family down",
    value: 0,
  },
  {
    id: 7,
    questionId: "PHQ_Q7",
    name: "Trouble concentrating on things, such as reading the newspaper or watching television",
    value: 0,
  },
  {
    id: 8,
    questionId: "PHQ_Q8",
    name: "Moving or speaking so slowly that other people could have noticed. Or the opposite being so figety or restless that you have been moving around a lot more than usual",
    value: 0,
  },
  {
    id: 9,
    questionId: "PHQ_Q9",
    name: "Thoughts that you would be better off dead, or of hurting yourself",
    value: 0,
  },
];

const PrimeScreenQuestionName = [
  {
    id: 1,
    questionId: "PS_Q1",
    name: "I think that I have felt that there are odd or unusual things going on that I can\'t explain",
    value: null,
  },
  {
    id: 2,
    questionId: "PS_Q2",
    name: "I think that I might be able to predict the future",
    value: null,
  },
  {
    id: 3,
    questionId: "PS_Q3",
    name: "I may have felt that there could possibly be something interrupting or controlling my thoughts, feelings, or actions",
    value: null,
  },
  {
    id: 4,
    questionId: "PS_Q4",
    name: "I have had the experience of doing something differently because of my superstitions",
    value: null,
  },
  {
    id: 5,
    questionId: "PS_Q5",
    name: "I think that I may get confused at times whether something I experience or perceive may be real or may be just part of my imagination or dreams",
    value: null,
  },
  {
    id: 6,
    questionId: "PS_Q6",
    name: "I have thought that it might be possible that other people can read my mind, or that I can read other\'s minds",
    value: null,
  },
  {
    id: 7,
    questionId: "PS_Q7",
    name: "I wonder if people may be planning to hurt me or even may be about to hurt me",
    value: null,
  },
  {
    id: 8,
    questionId: "PS_Q8",
    name: "I believe that I have special natural or supernatural gifts beyond my talents and natural strengths",
    value: null,
  },
  {
    id: 9,
    questionId: "PS_Q9",
    name: "I think I might feel like my mind is “playing tricks” on me",
    value: null,
  },
  {
    id: 10,
    questionId: "PS_Q10",
    name: "I have had the experience of hearing faint or clear sounds of people or a person mumbling or talking when there is no one near me",
    value: null,
  },
  {
    id: 11,
    questionId: "PS_Q11",
    name: "I think that I may hear my own thoughts being said out loud",
    value: null,
  },
  {
    id: 12,
    questionId: "PS_Q12",
    name: "I have been concerned that I might be “going crazy”",
    value: null,
  },
];

const ACE = [
  {
    id: 1,
    questionId: "ACE_Q1",
    name: "Did you lose a parent through divorce, abandonment, death, or other reason?",
    value: false,
  },
  {
    id: 2,
    questionId: "ACE_Q2",
    name: "Did you live with anyone who was depressed, mentally ill, or attempted suicide?",
    value: false,
  },
  {
    id: 3,
    questionId: "ACE_Q3",
    name: "Did you feel that you didn\'t have enough to eat, had to wear dirty clothes, or had no one to protect or take care of you?",
    value: false,
  },
  {
    id: 4,
    questionId: "ACE_Q4",
    name: "Did your parents or adultsin your home ever hit, punch, beat, or threaten to harm each other?",
    value: false,
  },
  {
    id: 5,
    questionId: "ACE_Q5",
    name: "Did you live with anyone who went to jail or prison?",
    value: false,
  },
  {
    id: 6,
    questionId: "ACE_Q6",
    name: "Did a parent or adult in your home ever swear at you, insult you, or put you down?",
    value: false,
  },
  {
    id: 7,
    questionId: "ACE_Q7",
    name: " Did a parent or adult in your home ever hit, beat, kick, or physically hurt you in any way?",
    value: false,
  },
  {
    id: 8,
    questionId: "ACE_Q8",
    name: "Did you feel that no one in your family loved you or thought you were special?",
    value: false,
  },
  {
    id: 9,
    questionId: "ACE_Q9",
    name: "Did you experience unwanted sexual contact (such as fondling or oral/anal/vaginal intercourse/penetration)?",
    value: false,
  },
  {
    id: 10,
    questionId: "ACE_Q10",
    name: "Did you live with anyone who had a problem with drinking or using drugs, including prescription drugs?",
    value: false,
  },
  {
    id: 11,
    questionId: "ACE_Q11",
    name: "Do you believe that these experiences have affected your health?",
    value: false,
    type: "radio",
    buttons: [
      { label: "Not Much", value: "not-much" },
      { label: "Some", value: "some" },
      { label: "A Lot", value: "a-lot" },
    ],
  },
];

const CATS = [
  {
    id: 1,
    questionId: "CATS_Q1",
    name: "Serious natural disaster like a flood, tornado, hurricane, earthquake, or fire.",
    value: 0,
  },
  {
    id: 2,
    questionId: "CATS_Q2",
    name: "Serious accident or injury like a car/bike crash, dog bite, sports injury.",
    value: 0,
  },
  {
    id: 3,
    questionId: "CATS_Q3",
    name: "Robbed by threat, force or weapon. ",
    value: 0,
  },
  {
    id: 4,
    questionId: "CATS_Q4",
    name: "Slapped, punched, or beat up in your family.",
    value: 0,
  },
  {
    id: 5,
    questionId: "CATS_Q5",
    name: "Slapped, punched, or beat up by someone not in your family.",
    value: 0,
  },
  {
    id: 6,
    questionId: "CATS_Q6",
    name: "Seeing someone in your family get slapped, punched or beat up.",
    value: 0,
  },
  {
    id: 7,
    questionId: "CATS_Q7",
    name: "Seeing someone in the community get slapped, punched or beat up.",
    value: 0,
  },
  {
    id: 8,
    questionId: "CATS_Q8",
    name: "Someone older touching your private parts when they shouldn\'t.",
    value: 0,
  },
  {
    id: 9,
    questionId: "CATS_Q9",
    name: "Someone forcing or pressuring sex, or when you couldn\'t say no.",
    value: 0,
  },
  {
    id: 10,
    questionId: "CATS_Q10",
    name: "Someone close to you dying suddenly or violently.",
    value: 0,
  },
  {
    id: 11,
    questionId: "CATS_Q11",
    name: "Attacked, stabbed, shot at or hurt badly.",
    value: 0,
  },
  {
    id: 12,
    questionId: "CATS_Q12",
    name: "Seeing someone attacked, stabbed, shot at, hurt badly or killed.",
    value: 0,
  },
  {
    id: 13,
    questionId: "CATS_Q13",
    name: "Stressful or scary medical procedure.",
    value: 0,
  },
  {
    id: 14,
    questionId: "CATS_Q14",
    name: "Being around war.",
    value: 0,
  },
  {
    id: 15,
    questionId: "CATS_Q15",
    name: "Other stressful or scary event?",
    type: "question",
    value: "",
    isSelected: null,
  },
];

const RecentValues = [
  {
    id: 1,
    questionId: "RI_Q1",
    name: "Upsetting thoughts or pictures about what happened that pop into your head. ",
    value: 0,
  },
  {
    id: 2,
    questionId: "RI_Q2",
    name: "Bad dreams reminding you of what happened.",
    value: 0,
  },
  {
    id: 3,
    questionId: "RI_Q3",
    name: "Feeling as if what happened is happening all over again.",
    value: 0,
  },
  {
    id: 4,
    questionId: "RI_Q4",
    name: "Feeling very upset when you are reminded of what happened.",
    value: 0,
  },
  {
    id: 5,
    questionId: "RI_Q5",
    name: "Strong feelings in your body when you are reminded of what happened (sweating, heart beating fast, upset stomach).  ",
    value: 0,
  },
  {
    id: 6,
    questionId: "RI_Q6",
    name: "Trying not to think about or talk about what happened. Or to not have feelings about it. ",
    value: 0,
  },
  {
    id: 7,
    questionId: "RI_Q7",
    name: "Staying away from people, places, things, or situations that remind you of what happened.  ",
    value: 0,
  },
  {
    id: 8,
    questionId: "RI_Q8",
    name: "Not being able to remember part of what happened. ",
    value: 0,
  },
  {
    id: 9,
    questionId: "RI_Q9",
    name: "Negative thoughts about yourself or others. Thoughts like I won\'t have a good life, no one can be trusted, the whole world is unsafe. ",
    value: 0,
  },
  {
    id: 10,
    questionId: "RI_Q10",
    name: " Blaming yourself for what happened, or blaming someone else when it isn\'t their fault. ",
    value: 0,
  },
  {
    id: 11,
    questionId: "RI_Q11",
    name: "Bad feelings (afraid, angry, guilty, ashamed) a lot of the time.",
    value: 0,
  },
  {
    id: 12,
    questionId: "RI_Q12",
    name: "Not wanting to do things you used to do. ",
    value: 0,
  },
  {
    id: 13,
    questionId: "RI_Q13",
    name: "Not feeling close to people.  ",
    value: 0,
  },
  {
    id: 14,
    questionId: "RI_Q14",
    name: "Not being able to have good or happy feelings. ",
    value: 0,
  },
  {
    id: 15,
    questionId: "RI_Q15",
    name: "Feeling mad. Having fits of anger and taking it out on others. ",
    value: 0,
  },
  {
    id: 16,
    questionId: "RI_Q16",
    name: "Doing unsafe things. ",
    value: 0,
  },
  {
    id: 17,
    questionId: "RI_Q17",
    name: "Being overly careful or on guard (checking to see who is around you). ",
    value: 0,
  },
  {
    id: 18,
    questionId: "RI_Q18",
    name: "Being jumpy. ",
    value: 0,
  },
  {
    id: 19,
    questionId: "RI_Q19",
    name: "Problems paying attention. ",
    value: 0,
  },
  {
    id: 20,
    questionId: "RI_Q20",
    name: "Trouble falling or staying asleep. ",
    value: 0,
  },
];

const Interference = [
  {
    id: 1,
    questionId: "ITF_Q1",
    name: "Getting along with others ",
    value: 0,
  },
  {
    id: 2,
    questionId: "ITF_Q2",
    name: "Hobbies/Fun  ",
    value: 0,
  },
  {
    id: 3,
    questionId: "ITF_Q3",
    name: "School or work  ",
    value: 0,
  },
  {
    id: 4,
    questionId: "ITF_Q4",
    name: "Family relationships ",
    value: 0,
  },
  {
    id: 5,
    questionId: "ITF_Q5",
    name: "General happiness  ",
    value: 0,
  },
];

const MoodDisorderQuestions = [
  {
    id: 1,
    questionId: "MDQ_SQ1",
    name: " ...you felt so good or so hyper that other people thought you were not your  normal self or you were so hyper that you got into trouble?",
    value: null,
  },
  {
    id: 2,
    questionId: "MDQ_SQ2",
    name: " ...you were so irritable that you shouted at people or started fights or arguments?",
    value: null,
  },
  {
    id: 3,
    questionId: "MDQ_Q3",
    name: "...you felt much more self-confident than usual?",
    value: null,
  },
  {
    id: 4,
    questionId: "MDQ_Q4",
    name: "...you got much less sleep than usual and found you didn\'t really miss it?",
    value: null,
  },
  {
    id: 5,
    questionId: "MDQ_Q5",
    name: "...you were much more talkative or spoke much faster than usual?",
    value: null,
  },
  {
    id: 6,
    questionId: "MDQ_Q6",
    name: "...thoughts raced through your head or you couldn\'t slow your mind down?",
    value: null,
  },
  {
    id: 7,
    questionId: "MDQ_Q7",
    name: "...you were so easily distracted by things around you that you had trouble concentrating or staying on track?",
    value: null,
  },
  {
    id: 8,
    questionId: "MDQ_Q8",
    name: "...you had much more energy than usual?",
    value: null,
  },
  {
    id: 9,
    questionId: "MDQ_Q9",
    name: "...you were much more active or did many more things than usual?",
    value: null,
  },
  {
    id: 10,
    questionId: "MDQ_Q10",
    name: "...you were much more social or outgoing than usual, for example, you telephoned friends in the middle of the night?",
    value: null,
  },
  {
    id: 11,
    questionId: "MDQ_Q11",
    name: "...you were much more interested in sex than usual?",
    value: null,
  },
  {
    id: 12,
    questionId: "MDQ_Q12",
    name: "...you did things that were unusual for you or that other people might have thought were excessive, foolish, or risky?",
    value: null,
  },
  {
    id: 13,
    questionId: "MDQ_Q13",
    name: "...spending money got you or your family into trouble?",
    value: null,
  },
];

const MoodDisorder = [
  {
    id: 1,
    questionId: "MDQ_Q1",
    name: " Has there ever been a period of time when you were not your usual self and...",
    value: Array(MoodDisorderQuestions.length).fill(null),
    type: null,
    question: MoodDisorderQuestions,
  },
  {
    id: 2,
    questionId: "MDQ_Q2",
    name: "If you checked YES to more than one of the above, have several of these ever happened during the same period of time?",
    value: null,
    type: "boolean",
    isSelected: null,
    openId: 3,
  },
  {
    id: 3,
    questionId: "MDQ_Q3",
    name: "How much of a problem did any of these cause you – like being unable to work; having family, money or legal troubles; getting into arguments or fights?",
    value: 0,
    type: "dropdown",
    isOpen: 0,
    option: [
      {
        label: "No problem",
        value: 0,
      },
      {
        label: "Minor problem ",
        value: 1,
      },
      {
        label: "Moderate problem",
        value: 2,
      },
      {
        label: "Serious problem",
        value: 3,
      },
    ],
  },
  {
    id: 4,
    questionId: "MDQ_Q4",
    name: " Have any of your blood relatives (i.e. children, siblings, parents, grandparents, aunts, uncles) had manic-depressive illness or bipolar disorder?",
    value: null,
    type: "boolean",
  },
  {
    id: 5,
    questionId: "MDQ_Q5",
    name: " Has a health professional ever told you that you have manic-depressive illness or bipolar disorder?",
    value: null,
    type: "boolean",
  },
];


const NICHQ = [
  {
    id: 1,
    questionId: "NICH_Q1",
    name: "Does not pay attention to details or makes careless mistakes with, for example, homework",
    value: 0,
  },
  {
    id: 2,
    questionId: "NICH_Q2",
    name: "Has difficulty keeping attention to what needs to be done",
    value: 0,
  },
  {
    id: 3,
    questionId: "NICH_Q3",
    name: "Does not seem to listen when spoken to directly",
    value: 0,
  },
  {
    id: 4,
    questionId: "NICH_Q4",
    name: "Does not follow through when given directions and fails to finish activities (not due to refusal or failure to understand)",
    value: 0,
  },
  {
    id: 5,
    questionId: "NICH_Q5",
    name: "Has difficulty organizing tasks and activities",
    value: 0,
  },
  {
    id: 6,
    questionId: "NICH_Q6",
    name: "Avoids, dislikes, or does not want to start tasks that require ongoing mental effort",
    value: 0,
  },
  {
    id: 7,
    questionId: "NICH_Q7",
    name: "Loses things necessary for tasks or activities (toys, assignments, pencils or books)",
    value: 0,
  },
  {
    id: 8,
    questionId: "NICH_Q8",
    name: "Is easily distracted by noises or other stimuli",
    value: 0,
  },
  {
    id: 9,
    questionId: "NICH_Q9",
    name: "Is forgetful in daily activities",
    value: 0,
  },
  {
    id: 10,
    questionId: "NICH_Q10",
    name: "Fidgets with hands or feet or squirms in seat",
    value: 0,
  },
  {
    id: 11,
    questionId: "NICH_Q11",
    name: " Leaves seat when remaining seated is expected",
    value: 0,
  },
  {
    id: 12,
    questionId: "NICH_Q12",
    name: " Runs about or climbs too much when remaining seated is expected",
    value: 0,
  },
  {
    id: 13,
    questionId: "NICH_Q13",
    name: "Has difficulty playing or beginning quiet play activities",
    value: 0,
  },
  {
    id: 14,
    questionId: "NICH_Q14",
    name: "Is “on the go” or often acts as if “driven by a motor” ",
    value: 0,
  },
  {
    id: 15,
    questionId: "NICH_Q15",
    name: "Talks too much",
    value: 0,
  },
  {
    id: 16,
    questionId: "NICH_Q16",
    name: "Blurts out answers before questions have been completed",
    value: 0,
  },
  {
    id: 17,
    questionId: "NICH_Q17",
    name: "Has difficulty waiting his or her turn",
    value: 0,
  },
  {
    id: 18,
    questionId: "NICH_Q18",
    name: "Interrupts or intrudes in on others\' conversations and/or activities",
    value: 0,
  },
  {
    id: 19,
    questionId: "NICH_Q19",
    name: "Argues with adults",
    value: 0,
  },
  {
    id: 20,
    questionId: "NICH_Q20",
    name: "Loses temper",
    value: 0,
  },
  {
    id: 21,
    questionId: "NICH_Q21",
    name: "Actively defies or refuses to go along with adults\' requests or rules",
    value: 0,
  },
  {
    id: 22,
    questionId: "NICH_Q22",
    name: "Deliberately annoys people",
    value: 0,
  },
  {
    id: 23,
    questionId: "NICH_Q23",
    name: "Blames others for his or her mistakes or misbehaviors",
    value: 0,
  },
  {
    id: 24,
    questionId: "NICH_Q24",
    name: "Is touchy or easily annoyed by others",
    value: 0,
  },
  {
    id: 25,
    questionId: "NICH_Q25",
    name: "Is angry or resentful",
    value: 0,
  },
  {
    id: 26,
    questionId: "NICH_Q26",
    name: "Is spiteful and wants to get even",
    value: 0,
  },
  {
    id: 27,
    questionId: "NICH_Q27",
    name: "Bullies, threatens, or intimidates others",
    value: 0,
  },
  {
    id: 28,
    questionId: "NICH_Q28",
    name: "Starts physical fights",
    value: 0,
  },
  {
    id: 29,
    questionId: "NICH_Q29",
    name: "Lies to get out of trouble or to avoid obligations (ie,“cons” others)",
    value: 0,
  },
  {
    id: 30,
    questionId: "NICH_Q30",
    name: "Is truant from school (skips school) without permission",
    value: 0,
  },
  {
    id: 31,
    questionId: "NICH_Q31",
    name: "Is physically cruel to people",
    value: 0,
  },
  {
    id: 32,
    questionId: "NICH_Q32",
    name: "Has stolen things that have value",
    value: 0,
  },
  {
    id: 33,
    questionId: "NICH_Q33",
    name: "Deliberately destroys others\' property",
    value: 0,
  },
  {
    id: 34,
    questionId: "NICH_Q34",
    name: "Has used a weapon that can cause serious harm (bat, knife, brick, gun)",
    value: 0,
  },
  {
    id: 35,
    questionId: "NICH_Q35",
    name: "Is physically cruel to animals",
    value: 0,
  },
  {
    id: 36,
    questionId: "NICH_Q36",
    name: "Has deliberately set fires to cause damage",
    value: 0,
  },
  {
    id: 37,
    questionId: "NICH_Q37",
    name: "Has broken into someone else\'s home, business, or car",
    value: 0,
  },
  {
    id: 38,
    questionId: "NICH_Q38",
    name: "Has stayed out at night without permission ",
    value: 0,
  },
  {
    id: 39,
    questionId: "NICH_Q39",
    name: "Has run away from home overnight",
    value: 0,
  },
  {
    id: 40,
    questionId: "NICH_Q40",
    name: "Has forced someone into sexual activity",
    value: 0,
  },
  {
    id: 41,
    questionId: "NICH_Q41",
    name: "Is fearful, anxious, or worried",
    value: 0,
  },
  {
    id: 42,
    questionId: "NICH_Q42",
    name: "Is afraid to try new things for fear of making mistakes",
    value: 0,
  },
  {
    id: 43,
    questionId: "NICH_Q43",
    name: "Feels worthless or inferior",
    value: 0,
  },
  {
    id: 44,
    questionId: "NICH_Q44",
    name: "Blames self for problems, feels guilty",
    value: 0,
  },
  {
    id: 45,
    questionId: "NICH_Q45",
    name: "Feels lonely, unwanted, or unloved; complains that “no one loves him or her”",
    value: 0,
  },
  {
    id: 46,
    questionId: "NICH_Q46",
    name: "Is sad, unhappy, or depressed",
    value: 0,
  },
  {
    id: 47,
    questionId: "NICH_Q47",
    name: "Is self-conscious or easily embarrassed",
    value: 0,
  }
]


const NICHQ_PARENT_PERFORMANCE = [
  {
    id: 48,
    questionId: "NICH_PP1", //48......55
    name: "Overall school performance",
    value: 1,
  },
  {
    id: 49,
    questionId: "NICH_PP2",
    name: "Reading",
    value: 1,
  },
  {
    id: 50,
    questionId: "NICH_PP3",
    name: "Writing",
    value: 1,
  },
  {
    id: 51,
    questionId: "NICH_PP4",
    name: "Mathematics",
    value: 1,
  },
  {
    id: 52,
    questionId: "NICH_PP5",
    name: "Relationship with parents",
    value: 1,
  },
  {
    id: 53,
    questionId: "NICH_PP6",
    name: "Relationship with siblings",
    value: 1,
  },
  {
    id: 54,
    questionId: "NICH_PP7",
    name: "Relationship with peers",
    value: 1,
  },
  {
    id: 55,
    questionId: "NICH_PP8",
    name: "Participation in organized activities (eg, teams)",
    value: 1,
  }
]


const NICHQ_TEACHER_ASSESSMENT = [
  {
    id: 1,
    questionId: "NICHQ_TA1",// Till1- 35
    name: "Fails to give attention to details or makes careless mistakes in schoolwork",
    value: 0,
  },
  {
    id: 2,
    questionId: "NICHQ_TA2",
    name: "Has difficulty sustaining attention to tasks or activities ",
    value: 0,
  },
  {
    id: 3,
    questionId: "NICHQ_TA3",
    name: "Does not seem to listen when spoken to directly",
    value: 0,
  },
  {
    id: 4,
    questionId: "NICHQ_TA4",
    name: "Does not follow through on instructions and fails to finish schoolwork (not due to oppositional behavior or failure to understand)",
    value: 0,
  },
  {
    id: 5,
    questionId: "NICHQ_TA5",
    name: "Has difficulty organizing tasks and activities",
    value: 0,
  },
  {
    id: 6,
    questionId: "NICHQ_TA6",
    name: "Avoids, dislikes, or is reluctant to engage in tasks that require sustained mental effort",
    value: 0,
  },
  {
    id: 7,
    questionId: "NICHQ_TA7",
    name: "Loses things necessary for tasks or activities (school assignments, pencils, or books)",
    value: 0,
  },
  {
    id: 8,
    questionId: "NICHQ_TA8",
    name: "Is easily distracted by extraneous stimuli",
    value: 0,
  },
  {
    id: 9,
    questionId: "NICHQ_TA9",
    name: "Is forgetful in daily activities",
    value: 0,
  },
  {
    id: 10,
    questionId: "NICHQ_TA10",
    name: "Fidgets with hands or feet or squirms in seat",
    value: 0,
  },
  {
    id: 11,
    questionId: "NICHQ_TA11",
    name: "Leaves seat in classroom or in other situations in which remaining seated is expected",
    value: 0,
  },
  {
    id: 12,
    questionId: "NICHQ_TA12",
    name: "Runs about or climbs excessively in situations in which remaining seated is expected",
    value: 0,
  },
  {
    id: 13,
    questionId: "NICHQ_TA13",
    name: "Has difficulty playing or engaging in leisure activities quietly",
    value: 0,
  },
  {
    id: 14,
    questionId: "NICHQ_TA14",
    name: "Is “on the go” or often acts as if “driven by a motor”",
    value: 0,
  },
  {
    id: 15,
    questionId: "NICHQ_TA15",
    name: "Talks excessively",
    value: 0,
  },
  {
    id: 16,
    questionId: "NICHQ_TA16",
    name: "Blurts out answers before questions have been completed",
    value: 0,
  },
  {
    id: 17,
    questionId: "NICHQ_TA17",
    name: "Has difficulty waiting in line ",
    value: 0,
  },
  {
    id: 18,
    questionId: "NICHQ_TA18",
    name: "Interrupts or intrudes on others (eg, butts into conversations/games)",
    value: 0,
  },
  {
    id: 19,
    questionId: "NICHQ_TA19",
    name: "Loses temper",
    value: 0,
  },
  {
    id: 20,
    questionId: "NICHQ_TA20",
    name: "Actively defies or refuses to comply with adult\'s requests or rules",
    value: 0,
  },
  {
    id: 21,
    questionId: "NICHQ_TA21",
    name: "Is angry or resentful",
    value: 0,
  },
  {
    id: 22,
    questionId: "NICHQ_TA22",
    name: "Is spiteful and vindictive",
    value: 0,
  },
  {
    id: 23,
    questionId: "NICHQ_TA23",
    name: "Bullies, threatens, or intimidates others",
    value: 0,
  },
  {
    id: 24,
    questionId: "NICHQ_TA24",
    name: "Initiates physical fights",
    value: 0,
  },
  {
    id: 25,
    questionId: "NICHQ_TA25",
    name: "Lies to obtain goods for favors or to avoid obligations (eg, “cons” others)",
    value: 0,
  },
  {
    id: 26,
    questionId: "NICHQ_TA26",
    name: "Is physically cruel to people",
    value: 0,
  },
  {
    id: 27,
    questionId: "NICHQ_TA27",
    name: "Has stolen items of nontrivial value",
    value: 0,
  },
  {
    id: 28,
    questionId: "NICHQ_TA28",
    name: "Deliberately destroys others\' property",
    value: 0,
  },
  {
    id: 29,
    questionId: "NICHQ_TA29",
    name: "Is fearful, anxious, or worried",
    value: 0,
  },
  {
    id: 30,
    questionId: "NICHQ_TA30",
    name: "Is self-conscious or easily embarrassed",
    value: 0,
  },
  {
    id: 31,
    questionId: "NICHQ_TA31",
    name: "Is afraid to try new things for fear of making mistakes",
    value: 0,
  },
  {
    id: 32,
    questionId: "NICHQ_TA32",
    name: "Feels worthless or inferior",
    value: 0,
  },
  {
    id: 33,
    questionId: "NICHQ_TA33",
    name: "Blames self for problems; feels guilty",
    value: 0,
  },
  {
    id: 34,
    questionId: "NICHQ_TA34",
    name: "Feels lonely, unwanted, or unloved; complains that “no one loves him or her”",
    value: 0,
  },
  {
    id: 35,
    questionId: "NICHQ_TA35",
    name: "Is sad, unhappy, or depressed",
    value: 0,
  }
]


const NICHQ_TEACHER_PERFORMANCE = [
  {
    id: 36,
    questionId: "NICHQ_TP1",// FROM 36-38
    name: "Reading",
    value: 1,
  },
  {
    id:37,
    questionId: "NICHQ_TP2",
    name: "Mathematics",
    value: 1,
  },
  {
    id: 38,
    questionId: "NICHQ_TP3",
    name: "Written expression",
    value: 1,
  }
]

const NICHQ_TEACHER_BEH_PERFORMANCE = [
  {
    id: 39,
    questionId: "NICHQ_TP4",// FROM 39-43
    name: "Relationship with peers",
    value: 1,
  },
  {
    id: 40,
    questionId: "NICHQ_TP5",
    name: "Following directions",
    value: 1,
  },
  {
    id: 41,
    questionId: "NICHQ_TP6",
    name: "Disrupting class",
    value: 1,
  },
  {
    id: 42,
    questionId: "NICHQ_TP7",
    name: "Assignment completion",
    value: 1,
  },
  {
    id: 43,
    questionId: "NICHQ_TP8",
    name: "Organizational skills",
    value: 1,
  }
]



const NICHQ_FOLLOWUP_PARENT = [
  {
    id: 1,
    questionId: "NICHQ_FP1",// FROM 1-18
    name: "Does not pay attention to details or makes careless mistakes with, for example, homework",
    value: 0,
  },
  {
    id: 2,
    questionId: "NICHQ_FP2",
    name: "Has difficulty keeping attention to what needs to be done",
    value: 0,
  },
  {
    id: 3,
    questionId: "NICHQ_FP3",
    name: "Does not seem to listen when spoken to directly",
    value: 0,
  },
  {
    id: 4,
    questionId: "NICHQ_FP4",
    name: "Does not follow through when given directions and fails to finish activities (not due to refusal or failure to understand)",
    value: 0,
  },
  {
    id: 5,
    questionId: "NICHQ_FP5",
    name: "Has difficulty organizing tasks and activities ",
    value: 0,
  },
  {
    id: 6,
    questionId: "NICHQ_FP6",
    name: "Avoids, dislikes, or does not want to start tasks that require ongoing mental effort",
    value: 0,
  },
  {
    id: 7,
    questionId: "NICHQ_FP7",
    name: "Loses things necessary for tasks or activities (toys, assignments, pencils, or books)",
    value: 0,
  },
  {
    id: 8,
    questionId: "NICHQ_FP8",
    name: "Is easily distracted by noises or other stimuli",
    value: 0,
  },
  {
    id: 9,
    questionId: "NICHQ_FP9",
    name: "Is forgetful in daily activities",
    value: 0,
  },
  {
    id: 10,
    questionId: "NICHQ_FP10",
    name: "Fidgets with hands or feet or squirms in seat",
    value: 0,
  },
  {
    id: 11,
    questionId: "NICHQ_FP11",
    name: "Leaves seat when remaining seated is expected",
    value: 0,
  },
  {
    id: 12,
    questionId: "NICHQ_FP12",
    name: "Runs about or climbs too much when remaining seated is expected",
    value: 0,
  },
  {
    id: 13,
    questionId: "NICHQ_FP13",
    name: "Has difficulty playing or beginning quiet play activities",
    value: 0,
  },
  {
    id: 14,
    questionId: "NICHQ_FP14",
    name: "Is “on the go” or often acts as if “driven by a motor”",
    value: 0,
  },
  {
    id: 15,
    questionId: "NICHQ_FP15",
    name: "Talks too much",
    value: 0,
  },
  {
    id: 16,
    questionId: "NICHQ_FP16",
    name: "Blurts out answers before questions have been completed",
    value: 0,
  },
  {
    id: 17,
    questionId: "NICHQ_FP17",
    name: "Has difficulty waiting his or her turn",
    value: 0,
  },
  {
    id: 18,
    questionId: "NICHQ_FP18",
    name: "Interrupts or intrudes in on others\' conversations and/or activities",
    value: 0,
  }
]

const NICHQ_FOLLOWUP_PARENT_PERFORMANCE = [
  {
    id: 19,
    questionId: "NICHQ_FPP1",// FROM 19-26
    name: "Overall school performance",
    value: 1,
  },
  {
    id: 20,
    questionId: "NICHQ_FPP2",
    name: "Reading",
    value: 1,
  },
  {
    id:21,
    questionId: "NICHQ_FPP3",
    name: "Writing",
    value: 1,
  },
  {
    id: 22,
    questionId: "NICHQ_FPP4",
    name: "Mathematics",
    value: 1,
  },
  {
    id: 23,
    questionId: "NICHQ_FPP5",
    name: "Relationship with parents",
    value: 1,
  },
  {
    id: 24,
    questionId: "NICHQ_FPP6",
    name: "Relationship with siblings",
    value: 1,
  },
  {
    id: 25,
    questionId: "NICHQ_FPP7",
    name: "Relationship with peers",
    value: 1,
  },
  {
    id: 26,
    questionId: "NICHQ_FPP8",
    name: "Participation in organized activities (eg, teams)",
    value: 1,
  }
]


const NICHQ_FOLLOWUP_PARENT_SIDE_EFFECT = [
  {
    id: 1,
    questionId: "NICHQ_FPS1",//NO NO
    name: "Headache",
    value: 0,
  },
  {
    id: 2,
    questionId: "NICHQ_FPS2",
    name: "Stomachache",
    value: 0,
  },
  {
    id: 3,
    questionId: "NICHQ_FPS3",
    name: "Change of appetite—explain below",
    value: 0,
  },
  {
    id: 4,
    questionId: "NICHQ_FPS4",
    name: "Trouble sleeping",
    value: 0,
  },
  {
    id: 5,
    questionId: "NICHQ_FPS5",
    name: "Irritability in the late morning, late afternoon, or evening—explain below",
    value: 0,
  },
  {
    id: 6,
    questionId: "NICHQ_FPS6",
    name: "Socially withdrawn—decreased interaction with others",
    value: 0,
  },
  {
    id: 7,
    questionId: "NICHQ_FPS7",
    name: "Extreme sadness or unusual crying",
    value: 0,
  },
  {
    id: 8,
    questionId: "NICHQ_FPS8",
    name: "Dull, tired, listless behavior",
    value: 0,
  },
  {
    id: 9,
    questionId: "NICHQ_FPS9",
    name: "Tremors/feeling shaky",
    value: 0,
  },
  {
    id: 10,
    questionId: "NICHQ_FPS10",
    name: "Repetitive movements, tics, jerking, twitching, eye blinking—explain below",
    value: 0,
  },
  {
    id: 11,
    questionId: "NICHQ_FPS11",
    name: "Picking at skin or fingers, nail biting, lip or cheek chewing—explain below",
    value: 0,
  },
  {
    id: 12,
    questionId: "NICHQ_FPS12",
    name: "Sees or hears things that aren\'t there",
    value: 0,
  }
]

const NICHQ_FOLLOWUP_TEACHER = [
  {
    id: 1,
    questionId: "NICHQ_FT1",// FROM 1-18
    name: "Does not pay attention to details or makes careless mistakes with, for example, homework",
    value: 0,
  },
  {
    id: 2,
    questionId: "NICHQ_FT2",
    name: "Has difficulty keeping attention to what needs to be done",
    value: 0,
  },
  {
    id: 3,
    questionId: "NICHQ_FT3",
    name: "Does not seem to listen when spoken to directly",
    value: 0,
  },
  {
    id: 4,
    questionId: "NICHQ_FT4",
    name: "Does not follow through when given directions and fails to finish activities (not due to refusal or failure to understand)",
    value: 0,
  },
  {
    id: 5,
    questionId: "NICHQ_FT5",
    name: "Has difficulty organizing tasks and activities ",
    value: 0,
  },
  {
    id: 6,
    questionId: "NICHQ_FT6",
    name: "Avoids, dislikes, or does not want to start tasks that require ongoing mental effort",
    value: 0,
  },
  {
    id: 7,
    questionId: "NICHQ_FT7",
    name: "Loses things necessary for tasks or activities (toys, assignments, pencils, or books)",
    value: 0,
  },
  {
    id: 8,
    questionId: "NICHQ_FT8",
    name: "Is easily distracted by noises or other stimuli",
    value: 0,
  },
  {
    id: 9,
    questionId: "NICHQ_FT9",
    name: "Is forgetful in daily activities",
    value: 0,
  },
  {
    id: 10,
    questionId: "NICHQ_FT10",
    name: "Fidgets with hands or feet or squirms in seat",
    value: 0,
  },
  {
    id: 11,
    questionId: "NICHQ_FT11",
    name: "Leaves seat when remaining seated is expected",
    value: 0,
  },
  {
    id: 12,
    questionId: "NICHQ_FT12",
    name: "Runs about or climbs too much when remaining seated is expected",
    value: 0,
  },
  {
    id: 13,
    questionId: "NICHQ_FT13",
    name: "Has difficulty playing or beginning quiet play activities",
    value: 0,
  },
  {
    id: 14,
    questionId: "NICHQ_FT14",
    name: "Is “on the go” or often acts as if “driven by a motor”",
    value: 0,
  },
  {
    id: 15,
    questionId: "NICHQ_FT15",
    name: "Talks too much",
    value: 0,
  },
  {
    id: 16,
    questionId: "NICHQ_FT16",
    name: "Blurts out answers before questions have been completed",
    value: 0,
  },
  {
    id: 17,
    questionId: "NICHQ_FT17",
    name: "Has difficulty waiting his or her turn",
    value: 0,
  },
  {
    id: 18,
    questionId: "NICHQ_FT18",
    name: "Interrupts or intrudes in on others\' conversations and/or activities",
    value: 0,
  }
]

const NICHQ_FOLLOWUP_TEACHER_PERFORMANCE = [
  {
    id: 19,
    questionId: "NICHQ_FTP1",// FROM 19-26
    name: "Reading",
    value: 1,
  },
  {
    id: 20,
    questionId: "NICHQ_FTP2",
    name: "Mathematics",
    value: 1,
  },
  {
    id: 21,
    questionId: "NICHQ_FTP3",
    name: "Written expression",
    value: 1,
  },
  {
    id: 22,
    questionId: "NICHQ_FTP4",
    name: "Relationship with peers",
    value: 1,
  },
  {
    id: 23,
    questionId: "NICHQ_FTP5",
    name: "Following direction",
    value: 1,
  },
  {
    id: 24,
    questionId: "NICHQ_FTP6",
    name: "Disrupting class ",
    value: 1,
  },
  {
    id: 25,
    questionId: "NICHQ_FTP7",
    name: "Assignment completion",
    value: 1,
  },
  {
    id: 26,
    questionId: "NICHQ_FTP8",
    name: "Organizational skills",
    value: 1,
  }
]

const NICHQ_FOLLOWUP_TEACHER_SIDE_EFFECT = [
  {
    id: 1,
    questionId: "NICHQ_FTS1",
    name: "Headache",
    value: 0,
  },
  {
    id: 2,
    questionId: "NICHQ_FTS2",
    name: "Stomachache",
    value: 0,
  },
  {
    id: 3,
    questionId: "NICHQ_FTS3",
    name: "Change of appetite—explain below",
    value: 0,
  },
  {
    id: 4,
    questionId: "NICHQ_FTS4",
    name: "Trouble sleeping",
    value: 0,
  },
  {
    id: 5,
    questionId: "NICHQ_FTS5",
    name: "Irritability in the late morning, late afternoon, or evening—explain below",
    value: 0,
  },
  {
    id: 6,
    questionId: "NICHQ_FTS6",
    name: "Socially withdrawn—decreased interaction with others",
    value: 0,
  },
  {
    id: 7,
    questionId: "NICHQ_FTS7",
    name: "Extreme sadness or unusual crying",
    value: 0,
  },
  {
    id: 8,
    questionId: "NICHQ_FTS8",
    name: "Dull, tired, listless behavior",
    value: 0,
  },
  {
    id: 9,
    questionId: "NICHQ_FTS9",
    name: "Tremors/feeling shaky",
    value: 0,
  },
  {
    id: 10,
    questionId: "NICHQ_FTS10",
    name: "Repetitive movements, tics, jerking, twitching, eye blinking—explain below",
    value: 0,
  },
  {
    id: 11,
    questionId: "NICHQ_FTS11",
    name: "Picking at skin or fingers, nail biting, lip or cheek chewing—explain below",
    value: 0,
  },
  {
    id: 12,
    questionId: "NICHQ_FTS12",
    name: "Sees or hears things that aren\'t there",
    value: 0,
  }
]

const NICHQ_SET1_HEADERS = [
  {
    id: 1,
    questionId: 'NICHQ_H1_Q1',
    name: 'Today\'s Date',
    value: '',
    type: 'date'
  },
  {
    id: 2,
    questionId: "NICHQ_H1_Q2",
    name: "Child\'s Name",
    value: '',
    type: 'question'
  },
  {
    id: 3,
    questionId: "NICHQ_H1_Q3",
    name: "Date of Birth",
    value: '',
    type: 'date'
  }, {
    id: 4,
    questionId: "NICHQ_H1_Q4",
    name: "Parent\'s Name",
    value: '',
    type: 'question'
  },
  {
    id: 5,
    questionId: "NICHQ_H1_Q5",
    name: "Parent\'s Phone Number",
    value: '',
    type: 'question'
  },

  {
    id: 6,
    questionId: "NICHQ_H1_Q6",
    name: "Is this evaluation based on a time when the child",
    value: false,
    type: 'radio',
    buttons: [
      { label: "was on medication", value: "was on medication" },
      { label: "was not on medication", value: "was not on medication" },
      { label: "not sure", value: "not sure" },
    ],
  }
]

const NICHQ_SET2_HEADERS = [
  {
    id: 1,
    questionId: "NICHQ_H2_Q1",
    name: "Teacher\'s Name",
    value: '',
    type: 'question'
  },
  {
    id: 2,
    questionId: "NICHQ_H2_Q2",
    name: "Class Time",
    value: '',
    type: 'question'
  },
  {
    id: 3,
    questionId: "NICHQ_H2_Q3",
    name: "Class Name/Period",
    value: '',
    type: 'question'
  }, {
    id: 4,
    questionId: "NICHQ_H2_Q4",
    name: "Today\'s Date",
    value: '',
    type: 'date'
  },
  {
    id: 5,
    questionId: "NICHQ_H2_Q5",
    name: "Child\'s Name",
    value: '',
    type: 'question'
  },
  {
    id: 6,
    questionId: "NICHQ_H2_Q6",
    name: "Grade Level",
    value: '',
    type: 'question'
  },


  {
    id: 7,
    questionId: "NICHQ_H2_Q7",
    name: "Is this evaluation based on a time when the child",
    value: false,
    type: 'radio',
    buttons: [
      { label: "was on medication", value: "was on medication" },
      { label: "was not on medication", value: "was not on medication" },
      { label: "not sure", value: "not sure" },
    ],
  }
]

const NICHQ_SET3_HEADERS = [
  {
    id: 1,
    questionId: "NICHQ_H3_Q1",
    name: "Today\'s Date",
    value: '',
    type: 'date'
  },
  {
    id: 2,
    questionId: "NICHQ_H3_Q2",
    name: "Child\'s Name",
    value: '',
    type: 'question'
  },
  {
    id: 3,
    questionId: "NICHQ_H3_Q3",
    name: "Date of Birth",
    value: '',
    type: 'date'
  }, {
    id: 4,
    questionId: "NICHQ_H3_Q4",
    name: "Parent\'s Name",
    value: '',
    type: 'question'
  },
  {
    id: 5,
    questionId: "NICHQ_H3_Q5",
    name: "Parent\'s Phone Number",
    value: '',
    type: 'question'
  },

  {
    id: 6,
    questionId: "NICHQ_H3_Q6",
    name: "Is this evaluation based on a time when the child",
    value: false,
    type: 'radio',
    buttons: [
      { label: "was on medication", value: "was on medication" },
      { label: "was not on medication", value: "was not on medication" },
      { label: "not sure", value: "not sure" },
    ],
  }
]

const NICHQ_SET4_HEADERS = [
  {
    id: 1,
    questionId: "NICHQ_H4_Q1",
    name: "Teacher\'s Name",
    value: '',
    type: 'question'
  },
  {
    id: 2,
    questionId: "NICHQ_H4_Q2",
    name: "Class Time",
    value: '',
    type: 'question'
  },
  {
    id: 3,
    questionId: "NICHQ_H4_Q3",
    name: "Class Name/Period",
    value: '',
    type: 'question'
  }, {
    id: 4,
    questionId: "NICHQ_H4_Q4",
    name: "Today\'s Date",
    value: '',
    type: 'date'
  },
  {
    id: 5,
    questionId: "NICHQ_H4_Q5",
    name: "Child\'s Name",
    value: '',
    type: 'question'
  },
  {
    id: 6,
    questionId: "NICHQ_H4_Q6",
    name: "Grade Level",
    value: '',
    type: 'question'
  },


  {
    id: 7,
    questionId: "NICHQ_H4_Q7",
    name: "Is this evaluation based on a time when the child",
    value: false,
    type: 'radio',
    buttons: [
      { label: "was on medication", value: "was on medication" },
      { label: "was not on medication", value: "was not on medication" },
      { label: "not sure", value: "not sure" },
    ],
  }
]

const NICHQ_S1_COMMENT = [
  {
    id: 1,
    questionId: "NICHQ_S1_C1",
    name: "",
    value: '',
    type: 'question'
  }]

const NICHQ_S2_COMMENT = [
  {
    id: 1,
    questionId: "NICHQ_S2_C1",
    name: "",
    value: '',
    type: 'question'
  }]

const NICHQ_S3_COMMENT = [
  {
    id: 1,
    questionId: "NICHQ_S3_C1",
    name: "",
    value: '',
    type: 'question'
  }]

const NICHQ_S4_COMMENT = [
  {
    id: 1,
    questionId: "NICHQ_S4_C1",
    name: "",
    value: '',
    type: 'question'
  }]

export {
  GAD,
  Connor,
  PHQ,
  PrimeScreenQuestionName,
  ACE,
  CATS,
  RecentValues,
  Interference,
  MoodDisorder,
  NICHQ,
  NICHQ_PARENT_PERFORMANCE,
  NICHQ_TEACHER_ASSESSMENT,
  NICHQ_TEACHER_PERFORMANCE,
  NICHQ_TEACHER_BEH_PERFORMANCE,
  NICHQ_FOLLOWUP_PARENT,
  NICHQ_FOLLOWUP_PARENT_PERFORMANCE,
  NICHQ_FOLLOWUP_PARENT_SIDE_EFFECT,
  NICHQ_FOLLOWUP_TEACHER,
  NICHQ_FOLLOWUP_TEACHER_PERFORMANCE,
  NICHQ_FOLLOWUP_TEACHER_SIDE_EFFECT,
  NICHQ_SET1_HEADERS,
  NICHQ_SET2_HEADERS,
  NICHQ_SET3_HEADERS,
  NICHQ_SET4_HEADERS,
  NICHQ_S1_COMMENT,
  NICHQ_S2_COMMENT,
  NICHQ_S3_COMMENT,
  NICHQ_S4_COMMENT
};
